/**
 * Tries to optimize requests so that they are not called in succession or called excessively
 */
import axios from 'axios';

// API doesn't accept X-CSRF-TOKEN as a header
axios.defaults.headers.common = {
    'Content-Type': 'application/json',
    'Accept-Encoding': 'gzip, deflate',
    'Cache-Control': 'max-age=300, public', // 5 minutes
    Accept: 'application/json, text/json, application/xml, text/xml',
};

// axios.defaults.xsrfHeaderName = null;
axios.defaults.xsrfCookieName = null;
// always pass the cookies
axios.defaults.withCredentials = true;

const axiosOptions = {
    withCredentials: true,
};

// bucket of ongoing requests based on the URL being called
const ongoingRequests = {};

/**
 * Clean up requests when they are done
 *
 * @param {string} key
 * @type {number} timeout
 */
function finished(key, timeout = 0) {
    setTimeout(() => {
        ongoingRequests[key] = null;
    }, timeout); // only allow these requests for the given time out
}

/**
 * Run a GET request
 *
 * @type {string} url
 * @type {Object} params
 * @type {number} timeout
 *
 * @returns {Promise}
 */
export const get = (url, params = {}, timeout = 0) => {
    // make a stringified version of this request
    const key = JSON.stringify({
        url,
        params,
    });

    // are there any ongoing requests? if yes, return them instead
    if (ongoingRequests[key]) {
        return ongoingRequests[key];
    }

    ongoingRequests[key] = axios.get(url, {
        params,
        ...axiosOptions,
    }).finally(() => finished(key, timeout));

    return ongoingRequests[key];
}

export default {
    get,
    // fill in the rest of axios as native functionality
    post: axios.post,
    patch: axios.patch,
    put: axios.put,
    delete: axios.delete,
}



// WEBPACK FOOTER //
// ./resources/assets/js/helpers/axios-helper.js